import React, { useEffect, useState } from "react";
import MDButton from "components/MDButton";
import config from "config/config";
import { googleSignIn } from "../_request";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context";
import SimpleBackdrop from "components/MDLoader_Backdrop";
import googleIcon from "../../../assets/images/google_icon.svg";

function SignInWithGoogle() {
  const { saveAuthData } = useAuth();
  const navigate = useNavigate();
  const [loginLoader, setLoginLoader] = useState(false);
  const googleLogin = () => {
    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].GOOGLE_CLIENT_ID
      }&redirect_uri=${config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].GOOGLE_REDIRECT_URI
      }&response_type=code&scope=openid%20email%20profile&access_type=offline&prompt=consent`;
    window.location.href = googleAuthUrl;
  };

  const handleGoogleResponse = async (code, state) => {
    const reqData = {
      code: code,
      userType: "CUSTOMER",
    };

    if (state?.campaignCode) {
      reqData['campaignCode'] = state.campaignCode;
    }
    if (state?.restaurantStoreId) {
      reqData['restaurantStoreId'] = state.restaurantStoreId;
    }
    if (state?.origin) {
      reqData['origin'] = state.origin;
    }
    
    setLoginLoader(true);
    const {
      data: { data, success },
    } = await googleSignIn(reqData);
    if (success) {
      setLoginLoader(false);
      saveAuthData(data?.tokens);
      
      navigate(`/dashboard${state.gtmCode ? `?s=${state.gtmCode}` : ""}`);
    } else {
      setLoginLoader(false);
      console.error("Google sign-in failed:", data);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    let googleState = params.get("state")
      ? JSON.parse(decodeURIComponent(params.get("state")))
      : {};

    if (code) {
      handleGoogleResponse(code, googleState);
    }
  }, [location.search]);

  return (
    <div>
      <MDButton
        variant="outlined"
        color="secondary"
        fullWidth
        onClick={() => googleLogin()}
        sx={{
          borderRadius: "8px",
          py: 1.5,
          background: "#E8E8E8",
          borderColor: "#E8E8E8",
          marginTop: "1rem",
          color: "#475467",
          textTransform: "none",
          fontWeight: "500",
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          "&:hover": {
            background: "#D1D1D1",
            borderColor: "#D1D5DB",
            color: "#101828",
          },
        }}
      >
        <img src={googleIcon} alt="Google" style={{ width: 22, height: 22 }} />
        Continue with Google
      </MDButton>

      {loginLoader && <SimpleBackdrop />}
    </div>
  );
}

export default SignInWithGoogle;
